




















































































































































































/* eslint-disable handle-callback-err */
import { jsPDF } from 'jspdf';

import { router } from '../../main';

import { Vue, Component, Prop } from 'vue-property-decorator';
import { RouteNames } from './_routes';

import { Subscription } from 'vue-rx-decorators';
import { Cache, InmateSelected, Titles, CoursesSelected, NewEnrollmentData, NewEnrollmentConfirmationData } from '../../common/cache';
import * as lantern from '@lantern/lantern-sdk';
import { alert } from '@/common/modal';
import { log } from 'util';

const retry = require('async-retry');
export const retryOptions = {
    retries: 5,
    minTimeout: 15,
    maxTimeout: 4000,
};

@Component({})
export default class ConfirmationComponent extends Vue {

    @Subscription(() => Cache.instance.inmatesSelected)
    inmatesSelected!: InmateSelected | {};

    @Subscription(() => Cache.instance.coursesSelected)
    coursesSelected!: CoursesSelected | {};

    @Subscription(() => Cache.instance.cvsFileData)
    cvsFileData!: NewEnrollmentData | null;

    @Subscription(() => Cache.instance.facility)
    facility!: lantern.Facilities.Document | null;

    @Subscription(() => Cache.instance.isAdmin)
    isAdmin!: boolean | null;

    cvsFileDataConfirmation: NewEnrollmentConfirmationData | null = null;

    routerNames = RouteNames;
    loader = false;

    shipTableTotAll = false;

    @Prop() title!: string;

    studentRegistration = false;
    studentRegistrationAndEnrollment = false;
    csvFile = false;
    modal = {
        selected: {
            locked: false,
            show: false,
        },
    };

    jpay = lantern.InmateSource.jpay;
    source = this.facility?.inmateSource;

    rerunRegistration = false;

    // #region SET VIEW
    async created() {

        this.source = this.facility?.inmateSource;
        if (this.$cache.isAdmin.value === null) {
            const { isAdmin } = (await this.$lantern.endpoints.User.isAdmin()).data;
            this.$cache.isAdmin.next(isAdmin);
        }

        this.setupView();
        this.shipTableTotAll = false;

        if (Object.keys(this.$cache.inmatesSelected.value).length === 0 && !this.cvsFileData) this.modal.selected.show = true;

        this.inmatesSelected = this.$cache.inmatesSelected.value;

        window.addEventListener('beforeunload', (event) => {
            event.returnValue = 'Inmate list will be lost - are you sure?';
        });
    }

    async setupView() {
        if (this.title === Titles.studentsOnly) {
            this.studentRegistration = true; this.studentRegistrationAndEnrollment = false; this.csvFile = false;
        } else if (this.title === Titles.studentsEnrollment) {
            this.studentRegistrationAndEnrollment = true; this.studentRegistration = false; this.csvFile = false;
        } else if (this.title === Titles.cvsFile) {
            this.csvFile = true; this.studentRegistrationAndEnrollment = false; this.studentRegistration = false;
        }
    }

    selectedCount() {
        let selected = 0;
        for (const site in this.inmatesSelected) {
            if (this.inmatesSelected.hasOwnProperty(site)) {
                selected += (this.inmatesSelected as any)[site].length;
            }
        }
        return selected;
    }

    selectedCountCourses() {
        let selected = 0;
        for (const course in this.coursesSelected) {
            if (this.coursesSelected.hasOwnProperty(course)) {
                selected += (this.coursesSelected as any)[course].length;
            }
        }
        return selected;
    }

    modalClick() {
        this.modal.selected.show = false;
        this.navigateTo(RouteNames.inmates);
    }
    // #endregion SET VIEW

    // #region CONFIRM
    getRegistrationData() {
        this.loader = true;

        if (this.csvFile) {
            if (!this.cvsFileData) return null;

            return {
                facilityId: this.$route.params.facilityId,
                createdBy: this.$cache.user.value!.id,
                inmateEnrollments: this.cvsFileData.inmates,
                registrationCount: this.cvsFileData.registrationCount,
                studentCount: this.cvsFileData.studentCount
            };

        }

        // if data from 'select Inmates'
        const inmateEnrollments: lantern.Sessions.InmateEnrollment[] = [];
        let registrationCount = 0;

        for (const site in this.inmatesSelected) {
            if (this.inmatesSelected.hasOwnProperty(site)) {
                // eslint-disable-next-line no-loop-func
                (this.inmatesSelected as any)[site].forEach((el: any) => {
                    const [inmateId, lNname, fNmae, shipTabletString, sviscustodyAccout] = el.split(':');
                    let shipTablet = false;
                    if (shipTabletString === 'true') shipTablet = true;

                    const inmate: lantern.Sessions.InmateEnrollment = { inmateId, shipTablet, sviscustodyAccout };

                    if (!this.studentRegistration) {
                        inmate.courses = [];
                        for (const course in this.coursesSelected) {
                            if (this.coursesSelected.hasOwnProperty(course)) {

                                // if section was set manualy - use it or use default one
                                let sectionId: number;
                                if ((<CoursesSelected> this.coursesSelected)[course].pickedSection) {
                                    sectionId = (<CoursesSelected> this.coursesSelected)[course].pickedSection!.id;
                                } else {
                                    sectionId = (<CoursesSelected> this.coursesSelected)[course].sections[0].id;
                                }

                                inmate.courses?.push({ courseId: (this.coursesSelected as any)[course].id, sectionId });
                                registrationCount += 1;
                            }
                        }
                    }

                    inmateEnrollments.push(inmate);
                });
            }
        }
        const studentCount = inmateEnrollments.length;
        return {
            facilityId: this.$route.params.facilityId,
            createdBy: this.$cache.user.value!.id,
            inmateEnrollments,
            registrationCount,
            studentCount
        };

    }

    async confirm() {

        const registerData = this.getRegistrationData();

        if (!registerData) {
            await alert('Registration data is empty');
            return;
        }

        if (registerData.studentCount === 0) {
            await alert('No students to register!');
            return;
        }

        let docs: {id: string; createdOn: string}[] = [];
        let prop: string = '';
        try {
            const responce = await this.$lantern.endpoints.Sessions.create({ ...registerData });
            docs = responce.data;
            const PropsObj = {
                id: registerData!.studentCount.toString(),
                docs
            };
            prop = JSON.stringify(PropsObj);
        } catch (error) {
            await alert('Cannot create session! Please try later!');
            this.loader = false;
        }

        // enqueue to amazon
        console.log(docs);
        if (docs.length !== 0) {

            for (const doc of docs) {

                // eslint-disable-next-line no-await-in-loop
                await retry(async () => {
                    const result = await this.$lantern.endpoints.Aws.post({ id: doc.id, createdOn: new Date(doc.createdOn), rerunRegistration: this.rerunRegistration });
                    return result;
                }, {
                    ...retryOptions,
                    onRetry: async (err: any) => {
                        await alert('Session was created, but the task cannot be enqueued! Please try later to re-send the task on the Past Sessions screen');
                    }
                });
            }

            this.cleanSelectedData();
            this.navigateTo(this.routerNames.finish, prop);
            this.loader = false;

        }
    }

    navigateTo(page: RouteNames, prop? : string) {

        if (prop) {
            router.push({ name: page, params: { data: prop } });
        } else {
            router.push(page);
        }
    }
    // #endregion CONFIRM

    // #region PDF EXPORT

    dateFormate(dateString: string) {
        if (!dateString) return 'none';
        const date = new Date(dateString);
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' });
        const [{ value: month },, { value: day },, { value: year }] = dateTimeFormat.formatToParts(date);

        return `${month}-${day}-${year}`;
    }

    addPdfLine(height: number, doc: any) {

        height += 5;
        if (height === 280 || height > 280) {
            doc.addPage();
            height = 20;
        }
        return height;
    }

    async exportPdf() {

        this.loader = true;
        // eslint-disable-next-line new-cap
        const doc = new jsPDF();
        doc.setFontSize(14);
        doc.text(`Student Registartion on ${this.dateFormate(new Date().toString())} for ${this.facility!.displayName}`, 25, 10);
        doc.setFontSize(10);
        let height = 20;

        if (this.csvFile) {
            if (!this.cvsFileData) return;
            this.cvsFileData.inmates.forEach((el, index) => {
                doc.text(`${index + 1} - id:${el.inmateId} ${el.sisUserId}`, 20, height);
                height = this.addPdfLine(height, doc);
                if (el.courses) {
                    el.courses.forEach(course => {
                        doc.text(`Course id: ${course.courseId} / Section id:${course.sectionId}`, 30, height);
                        height = this.addPdfLine(height, doc);
                    });
                }
            });
        } else {
        // if data from 'select Inmates'
            for (const site in this.inmatesSelected) {
                if (this.inmatesSelected.hasOwnProperty(site)) {
                // eslint-disable-next-line no-loop-func
                    (this.inmatesSelected as any)[site].forEach((el: any, index: number) => {
                        const [inmateId, lNname, fNmae, shipTablet] = el.split(':');
                        doc.text(`${index + 1} - id:${inmateId} ${lNname} ${fNmae} ship tablet: ${shipTablet}`, 20, height);

                        if (!this.studentRegistration) {
                            for (const course in this.coursesSelected) {
                                if (this.coursesSelected.hasOwnProperty(course)) {
                                    height = this.addPdfLine(height, doc);

                                    if ((<CoursesSelected> this.coursesSelected)[course].pickedSection) {
                                        doc.text(`${(<CoursesSelected> this.coursesSelected)[course].pickedSection!.id} ${(<CoursesSelected> this.coursesSelected)[course].pickedSection!.name}`, 30, height); ;
                                    } else {
                                        doc.text(`${(<CoursesSelected> this.coursesSelected)[course].sections[0]!.id} ${(<CoursesSelected> this.coursesSelected)[course].sections[0]!.name}`, 30, height); ;
                                    }

                                }
                            }
                        }
                        height = this.addPdfLine(height, doc);
                    });
                }
            }
        }

        doc.save(`${this.$route.params.facilityId}_${this.dateFormate(new Date().toString())}_.pdf`);

        this.loader = false;
    }

    windowPrint() {
        window.print();
    }
    // #endregion Export PDF

    // #region TABLET ORDERS
    addShipTablet(indexInmate: any, index: any) {

        const [inmateId, lNname, fNmae, shipTablet] = (this.inmatesSelected as any)[index][indexInmate].split(':');
        if (shipTablet === 'false') {
            (this.inmatesSelected as any)[index][indexInmate] = `${inmateId}:${lNname}:${fNmae}:true`;
        } else {
            (this.inmatesSelected as any)[index][indexInmate] = `${inmateId}:${lNname}:${fNmae}:false`;
        }
        this.$cache.inmatesSelected.next(this.inmatesSelected);
    }

    shipTabletAll() {
        if (this.csvFile) {
            if (!this.cvsFileData) return;
            this.cvsFileData.inmates.forEach((el, index) => {
                if (!this.shipTableTotAll) {
                    el.shipTablet = true;
                } else {
                    el.shipTablet = false;
                }
            });

        } else {
            for (const site in this.inmatesSelected) {
                if (this.inmatesSelected.hasOwnProperty(site)) {
                    // eslint-disable-next-line no-loop-func
                    (this.inmatesSelected as any)[site].forEach((el: any, index: number) => {

                        const [inmateId, lNname, fNmae, shipTablet] = el.split(':');
                        if (!this.shipTableTotAll) {
                            (this.inmatesSelected as any)[site][index] = `${inmateId}:${lNname}:${fNmae}:true`;
                        } else {
                            (this.inmatesSelected as any)[site][index] = `${inmateId}:${lNname}:${fNmae}:false`;
                        }

                    });
                }
            }
        }

    }
    // #endregion TABLET ORDERS

    cleanSelectedData() {
        this.inmatesSelected = {};
        this.coursesSelected = {};
        this.cvsFileData = null;

        this.$cache.inmatesSelected.next(this.inmatesSelected);
        this.$cache.coursesSelected.next(this.coursesSelected);
        this.$cache.cvsFileData.next(this.cvsFileData);
    }

    cancelClick() {
        if (this.csvFile) {
            this.navigateTo(this.routerNames.import);
        } else {
            this.navigateTo(this.routerNames.inmates);
        }
    }
}
